import { WatchQueryFetchPolicy } from '@apollo/client';
import { useGetRecordByIdQuery } from 'generated/graphql';
import { useMemo } from 'react';
import { UUID } from 'v2/core/entities/uuid';
import { apolloStatusToQueryStatus } from 'v2/core/repository/edge-server/statusConvertor';
import { QueryStatus } from 'v2/core/repository/edge-server/types';
import { mapFeedback } from 'v2/core/repository/edge-server/utils/records';

export const useGetRecordFromEdgeServer = ({
  tenantID,
  recordID,
  timezone,
  fetchPolicy = 'cache-and-network',
}: {
  tenantID: UUID;
  recordID: UUID;
  timezone: string;
  fetchPolicy?: WatchQueryFetchPolicy;
}) => {
  const { data, loading, error, called } = useGetRecordByIdQuery({
    variables: {
      tenantID,
      recordID,
    },
    fetchPolicy,
    nextFetchPolicy: 'cache-first',
    skip: !recordID,
  });

  const status = apolloStatusToQueryStatus(loading, called, false, error);

  const record = useMemo(
    () =>
      mapFeedback(
        timezone,
        data?.getRecord ? [data.getRecord] : undefined,
        undefined,
      ),
    [data?.getRecord, timezone],
  );

  return {
    error,
    status: record ? QueryStatus.SUCCESS_COMPLETED : status,
    data: record,
  };
};
